// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ttO3","actions":"GroupTable_actions__3k-sB","deleteModalFooter":"GroupTable_deleteModalFooter__337EE"};